import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideModal as hideModalAction, MODAL_TYPE_CLIENT_EXAMINATION_ALERT, } from '../../../actions/ModalActions';
import { isShowModal } from '../../../helpers/modal';
import ExaminationAlertAndHeadCardFullModal from './ExaminationAlertAndHeadCardFullModal';
const ExaminationAlertAndHeadCardFullModalByReducer = () => {
    const dispatch = useDispatch();
    const isShowByModal = useSelector(({ modal }) => isShowModal(modal, MODAL_TYPE_CLIENT_EXAMINATION_ALERT));
    const hideModal = useCallback(() => {
        dispatch(hideModalAction(MODAL_TYPE_CLIENT_EXAMINATION_ALERT));
    }, [dispatch]);
    useEffect(() => {
        hideModal();
    }, [hideModal]);
    return (_jsx(ExaminationAlertAndHeadCardFullModal, { isShow: isShowByModal, onClickClose: hideModal }));
};
export default ExaminationAlertAndHeadCardFullModalByReducer;
